import {
  ExtendedTemplateItemOptions,
  FilenameTemplateItem,
} from './FilenameTemplateItem'
import { alphabeticalSort } from '../../../utils/alphabeticalSort'
import { OptionalTimeZone } from '../../timezones'

type Lot = {
  dateLotCreated?: Date
  createdDate?: Date
  densityTests: { dateTestCreated?: Date; createdDate?: Date }[]
  lotId?: string
}
export class LotFilenameTemplateItem<
  Property extends keyof Lot,
  ID extends string
> extends FilenameTemplateItem<Lot, 'Lot', Property, ID> {
  value<T extends Lot>(record: T | undefined, tz: OptionalTimeZone): string {
    if (this.property === 'dateLotCreated') {
      const tests = record?.['densityTests'] ?? []
      const [test] = tests.sort(alphabeticalSort('createdDate'))
      const value =
        test?.dateTestCreated ??
        record?.['dateLotCreated'] ??
        record?.['createdDate']
      return this.resolveDate(value, tz)
    } else if (this.property === 'lotId') return this.resolve(record?.['lotId'])
    else
      throw new Error(
        `${this.property} is a helper field as is not supported as a filename template item`
      )
  }
  /**
   * @see {@link FilenameTemplateItem}
   */
  constructor(options: ExtendedTemplateItemOptions<Lot, Property, ID>) {
    super({ classType: 'Lot', ...options })
  }
}

type MaterialSource = { source?: string; classification?: string }
export class MaterialSourceFilenameTemplateItem<
  Property extends keyof MaterialSource,
  ID extends string
> extends FilenameTemplateItem<MaterialSource, 'MaterialSource', Property, ID> {
  /**
   * @see {@link FilenameTemplateItem}
   */
  constructor(
    options: ExtendedTemplateItemOptions<MaterialSource, Property, ID>
  ) {
    super({ classType: 'MaterialSource', ...options })
  }
}

type MaterialRequirement = {
  materialSection?: string
  shortName?: string
}
export class MaterialRequirementFilenameTemplateItem<
  Property extends keyof MaterialRequirement,
  ID extends string
> extends FilenameTemplateItem<
  MaterialRequirement,
  'MaterialRequirement',
  Property,
  ID
> {
  /**
   * @see {@link FilenameTemplateItem}
   */
  constructor(
    options: ExtendedTemplateItemOptions<MaterialRequirement, Property, ID>
  ) {
    super({ classType: 'MaterialRequirement', ...options })
  }
}
